import {Injectable, inject, signal} from '@angular/core';
import {Storage} from './storage.service';

export type Theme = 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private storage = inject(Storage);
  private key = 'lusk_theme';
  private osMedia = window.matchMedia('(prefers-color-scheme: dark)');

  theme = signal<Theme>(this.load());

  constructor() {
    this.apply(this.theme());
    this.osMedia.addEventListener('change', this.onOsSchemeChange);
  }

  toggle() {
    const next = this.theme() === 'light' ? 'dark' : 'light';
    this.theme.set(next);
    this.storage.set(this.key, next);
    this.apply(next);
  }

  private onOsSchemeChange = (event: MediaQueryListEvent) => {
    // An explicit user choice wins over the OS preference.
    if (this.storage.get<string>(this.key)) return;
    const theme: Theme = event.matches ? 'dark' : 'light';
    this.theme.set(theme);
    this.apply(theme);
  };

  private load(): Theme {
    const stored = this.storage.get<string>(this.key);
    if (stored === 'light' || stored === 'dark') return stored;
    return this.osMedia.matches ? 'dark' : 'light';
  }

  private apply(theme: Theme) {
    document.documentElement.setAttribute('data-bs-theme', theme);
  }
}
